class ModFilterTabs {
  constructor(el) {
    this.$el = $(el);
    this.$slider = this.$el.find('.gg-filter-tabs__slider');
    this.$tabs = this.$el.find('.gg-filter-tabs__tab');
    this.$primaryTabs = this.$el.find('.gg-filter-tabs__primary-tab');
    this.$items = this.$el.find('.gg-filter-tabs__item');
    this.$prevBtn = this.$el.find('.slick-prev');
    this.$nextBtn = this.$el.find('.slick-next');
    this.$controls = this.$el.find('.slick-controls');
    this.currentTranslate = 0;
    this.currentIndex = 0;
    this.clsSlickDisabled = 'slick-disabled';
  }

  init() {
    this.bindEvents();
    if (this.$slider.length) {
      this.updateArrowState();
    }
    this.initStickyObserver();
  }

  initStickyObserver() {
    // Store initial position (before any sticky behavior)
    let initialTop = null;

    // Get header height from CSS variable
    const getHeaderHeight = () => {
      const headerHeight = getComputedStyle(document.documentElement)
        .getPropertyValue('--height-header')
        .trim();
      // eslint-disable-next-line radix
      return headerHeight ? parseInt(headerHeight) : 0;
    };

    // Get admin bar height if exists
    const getAdminBarHeight = () => {
      if (!document.body.classList.contains('admin-bar')) {
        return 0;
      }
      return window.innerWidth >= 768 ? 32 : 46;
    };

    // Check if header is hidden
    const isHeaderHidden = () => $('.wrapper').hasClass('header-hidden');

    // Calculate initial position on first call
    const getInitialTop = () => {
      if (initialTop === null) {
        // Temporarily remove is-sticky to get true position
        const wasSticky = this.$el.hasClass('is-sticky');
        this.$el.removeClass('is-sticky');
        initialTop =
          this.$el[0].getBoundingClientRect().top + window.pageYOffset;
        if (wasSticky) {
          this.$el.addClass('is-sticky');
        }
      }
      return initialTop;
    };

    // Check sticky state on scroll
    const checkSticky = () => {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const headerHeight = getHeaderHeight();
      const adminBarHeight = getAdminBarHeight();
      const elementInitialTop = getInitialTop();

      // Calculate when element should stick
      // When header is visible: stick when element reaches (headerHeight + adminBarHeight)
      // When header is hidden: stick when element reaches top (adminBarHeight only)
      let stickyPoint;
      if (isHeaderHidden()) {
        // Header is hidden, element should stick at top (plus admin bar)
        stickyPoint = elementInitialTop - adminBarHeight;
      } else {
        // Header is visible, element should stick below header
        stickyPoint = elementInitialTop - (headerHeight + adminBarHeight);
      }

      if (scrollTop >= stickyPoint) {
        this.$el.addClass('is-sticky');
      } else {
        this.$el.removeClass('is-sticky');
      }
    };

    // Initial check
    checkSticky();

    // Listen to scroll events with throttle for better performance
    let ticking = false;
    $(window).on('scroll.stickyTabs', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          checkSticky();
          ticking = false;
        });
        ticking = true;
      }
    });

    // Recheck on resize
    $(window).on('resize.stickyTabs', () => {
      // Reset to recalculate
      initialTop = null;
      checkSticky();
    });
  }

  bindEvents() {
    // Primary group tab click — rebuild secondary tabs via JS data (no page reload)
    this.$el.on('click', '.gg-filter-tabs__primary-tab', (e) => {
      e.preventDefault();
      const $tab = $(e.currentTarget);
      const primarySlug = $tab.data('primary-group');
      this.$primaryTabs.removeClass('active');
      $tab.addClass('active');
      this.afterPrimaryTab(primarySlug);
    });

    $(document).on('resourcePrimaryGroupChanged', (_e, value) => {
      if (value) {
        this.$primaryTabs.removeClass('active');
        this.$primaryTabs.filter(`[data-primary-group="${value}"]`).addClass('active');
        this.afterPrimaryTab(value);
      }
    });

    // Secondary tab clicks — delegated so rebuilt tabs also get handled
    this.$el.on('click', '.gg-filter-tabs__tab', (e) => {
      e.preventDefault();
      const $tab = $(e.currentTarget);
      const category = $tab.data('category');
      this.$el.find('.gg-filter-tabs__tab').removeClass('active');
      $tab.addClass('active');
      this.afterActiveTab(category);
    });

    if (this.$slider.length) {
      // Arrow click events
      this.$prevBtn.on('click', (e) => {
        e.preventDefault();
        this.scrollPrev();
      });

      this.$nextBtn.on('click', (e) => {
        e.preventDefault();
        this.scrollNext();
      });

      // Update arrow state on window resize
      $(window).on('resize', () => {
        this.updateArrowState();
      });
    }
  }

  afterPrimaryTab(primarySlug) {
    const groupsData = this.$el.data('groups') || {};
    const group = groupsData[primarySlug] || { categories: [], allowed: [] };
    const tabClass = this.$el.data('tab-class') || '';

    // Rebuild secondary tabs without page reload
    const $slider = this.$el.find('.gg-filter-tabs__slider');
    if ($slider.length) {
      let html = `<div class="gg-filter-tabs__item">
          <button type="button" class="${tabClass} gg-filter-tabs__tab active" data-category="">
            <span class="text-body font-bold">All</span>
          </button>
        </div>`;
      group.categories.forEach((cat) => {
        html += `<div class="gg-filter-tabs__item">
          <button type="button" class="${tabClass} gg-filter-tabs__tab" data-category="${cat.slug}">
            <span class="text-body font-bold">${cat.name}</span>
          </button>
        </div>`;
      });
      $slider.html(html);
      this.$items = this.$el.find('.gg-filter-tabs__item');
      this.currentTranslate = 0;
      this.currentIndex = 0;
      this.updateSliderPosition();
      this.updateArrowState();
    }

    // Update allowed-categories data for subsequent secondary tab clicks
    const allowedStr = group.allowed.join(',');
    this.$el.data('allowed-categories', allowedStr);

    // Update URL without reload
    const url = new URL(window.location.href);
    url.searchParams.set('primary_group', primarySlug);
    url.searchParams.delete('category');
    url.searchParams.delete('page');
    window.history.pushState({}, '', url.toString());

    // Trigger resource refresh
    const postType = this.$el.data('post-type') || 'news';
    $(document).trigger('filterTabsChanged', ['', postType, allowedStr]);
  }

  afterActiveTab(category) {
    const url = new URL(window.location.href);
    if (category === '') {
      url.searchParams.delete('category');
    } else {
      url.searchParams.set('category', category);
    }
    window.history.pushState({}, '', url.toString());
    const postType = this.$el.data('post-type') || 'news';
    const allowedCategories = this.$el.data('allowed-categories') || '';
    $(document).trigger('filterTabsChanged', [category, postType, allowedCategories]);
  }

  scrollPrev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.scrollToIndex(this.currentIndex);
    }
  }

  scrollNext() {
    if (this.currentIndex < this.$items.length - 1) {
      this.currentIndex++;
      this.scrollToIndex(this.currentIndex);
    }
  }

  scrollToIndex(index) {
    if (!this.$slider.length) {
      return;
    }

    const $item = this.$items.eq(index);
    if ($item.length) {
      const itemLeft = $item.position().left;
      const sliderWidth = this.$slider[0].scrollWidth;
      const containerWidth = this.$slider.parent().outerWidth();
      const maxScroll = -(sliderWidth - containerWidth);

      // Calculate target translate
      let targetTranslate = -itemLeft;

      // Don't scroll past the max (last item aligned to right)
      if (targetTranslate < maxScroll) {
        targetTranslate = maxScroll;
      }

      // Don't scroll past the start
      if (targetTranslate > 0) {
        targetTranslate = 0;
      }

      this.currentTranslate = targetTranslate;
      this.updateSliderPosition();
    }
  }

  updateSliderPosition() {
    this.$slider.css('transform', `translateX(${this.currentTranslate}px)`);
    this.updateArrowState();
  }

  updateArrowState() {
    if (!this.$slider.length || !this.$slider[0]) {
      return;
    }

    const sliderWidth = this.$slider[0].scrollWidth;
    const containerWidth = this.$slider.parent().outerWidth();
    const controlsHidden = sliderWidth < containerWidth + 100 && sliderWidth <= containerWidth + (window.innerWidth - containerWidth) / 2;

    if (controlsHidden) {
      this.$controls.addClass('hide');
      this.currentTranslate = 0;
      // Reset position without calling updateArrowState again to avoid infinite loop
      this.$slider.css('transform', `translateX(${this.currentTranslate}px)`);
      // return;
    } else {
      this.$controls.removeClass('hide');
    }

    // Calculate max scroll position (negative value)
    const maxScroll = -(sliderWidth - containerWidth);

    // Disable/enable prev button based on scroll position
    if (this.currentTranslate >= 0) {
      this.$prevBtn.addClass(this.clsSlickDisabled).prop('disabled', true);
    } else {
      this.$prevBtn.removeClass(this.clsSlickDisabled).prop('disabled', false);
    }

    // Disable/enable next button based on scroll position
    // Add small tolerance (1px) to account for rounding errors
    if (this.currentTranslate <= maxScroll + 1) {
      this.$nextBtn.addClass(this.clsSlickDisabled).prop('disabled', true);
    } else {
      this.$nextBtn.removeClass(this.clsSlickDisabled).prop('disabled', false);
    }
  }

  destroy() {
    this.$tabs.off('click');
    this.$prevBtn.off('click');
    this.$nextBtn.off('click');
    $(window).off('resize');
    $(window).off('scroll.stickyTabs');
    $(window).off('resize.stickyTabs');
  }
}

// Initialize on document ready
$(document).ready(() => {
  $('.gg-filter-tabs').each((_i, el) => {
    new ModFilterTabs(el).init();
  });
});
